import { render, staticRenderFns } from "./status-card.vue?vue&type=template&id=b12f4b3a&scoped=true&"
import script from "./status-card.vue?vue&type=script&lang=js&"
export * from "./status-card.vue?vue&type=script&lang=js&"
import style0 from "./status-card.vue?vue&type=style&index=0&id=b12f4b3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12f4b3a",
  null
  
)

export default component.exports